
import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import FeaturesSection from './components/FeaturesSection';
import SecuritySection from './components/SecuritySection';
import HowItWorksSection from './components/HowItWorksSection';
import GallerySection from './components/GallerySection';
import FAQSection from './components/FAQSection';
import SupportSection from './components/SupportSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';

export default function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Ensure we're on the client side before accessing document
    if (typeof window !== 'undefined') {
      if (mobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    }
    
    // Cleanup function
    return () => {
      if (typeof window !== 'undefined') {
        document.body.style.overflow = 'unset';
      }
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    // Add Schema.org JSON-LD for homepage
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Vollet",
      "applicationCategory": "FinanceApplication",
      "operatingSystem": ["Android", "iOS"],
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "description": "Vollet is a secure, non-custodial crypto wallet for everyday use. Send, receive and manage Bitcoin, Ethereum and popular tokens with ease.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "2500"
      },
      "featureList": [
        "Send & Receive Crypto",
        "Multi-Asset Support",
        "Portfolio View",
        "QR Payments",
        "Address Book",
        "Biometric Security"
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    script.id = 'schema-software-app';
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('schema-software-app');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <main>
        <HeroSection />
        <BenefitsSection />
        <FeaturesSection />
        <SecuritySection />
        <HowItWorksSection />
        <GallerySection />
        <FAQSection />
        <SupportSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
